import styled from 'styled-components';

const COLORS = {
  borderDefault: '#e2e8f0', 
  borderHover: '#cbd5e1',   
  borderFocus: '#00b4d8',   
  focusShadow: 'rgba(0, 180, 216, 0.1)', 
  textMain: '#334155',      
  textPlaceholder: '#94a3b8',
  bgWhite: '#ffffff',
};

export const StyledInput = styled.input`
  /* 尺寸与布局 */
  width: 100%; 
  height: 40px; 
  min-width: 0; 
  box-sizing: border-box;
  padding: 0 12px;

  /* 字体样式 */
  font-size: 14px;
  font-weight: 400; 
  color: ${COLORS.textMain};
  
  outline: none;
  box-shadow: none;
  font-family: inherit; 

  /* 边框与背景 */
  background-color: ${COLORS.bgWhite};
  border: 1px solid ${COLORS.borderDefault};
  border-radius: 8px;
  
  transition: all 0.2s ease-in-out;

  &::placeholder {
    color: ${COLORS.textPlaceholder};
    font-weight: 400;
  }

  &:hover:not(:disabled) {
    border-color: ${COLORS.borderHover};
  }

  &:focus:not(:disabled) {
    border-color: ${COLORS.borderFocus} !important; 
    box-shadow: 0 0 0 3px ${COLORS.focusShadow} !important;
  }

  &:disabled {
    background-color: #f8fafc;
    cursor: not-allowed;
    color: #94a3b8;
  }
`;